<template>
  <div class="htmldiv bgw topdiv">
    <router-link to="/zedu/index">
      <img src="../../assets/images/index_01_12.png" />
    </router-link>
    <router-link to="/" style="float: right;margin-top: 60px;">
      <img src="../../assets/images/go_home.jpg" />
    </router-link>
  </div>
</template>

<script>
  export default {
    name: "top",
    data () {
      return {
        action : 'index',
        keyword : '',
        to : '/zedu/index',
      }
    },
    mounted() {
      $('.topdiv input').focus(function(){
        var p = $(this).parent();
        p.css('box-shadow', '0 0 5px #3a8c39');
      })
      $('.topdiv input').blur(function(){
        $(this).parent().css('box-shadow', 'none');
      })
    },
    created() {
      var pathes = this.$router.currentRoute.path.split('/');
      this.action = pathes[2];
      if(this.action == 'index'){
        this.to = '/';
      }
    },
    methods:{
      search:function () {
        this.$router.push({path:'/search',query:{keyword:this.keyword}})
      }
    }
  }
</script>

<style scoped>
  .topdiv{height: 170px;}
</style>



// WEBPACK FOOTER //
// src/components/zedu/top.vue